export var SocketStatus = /*#__PURE__*/function (SocketStatus) {
  SocketStatus["idle"] = "idle";
  SocketStatus["open"] = "open";
  SocketStatus["closed"] = "closed";
  SocketStatus["connecting"] = "connecting";
  return SocketStatus;
}({});
export var IncomingMessageText = /*#__PURE__*/function (IncomingMessageText) {
  IncomingMessageText["messageSent"] = "Message sent successfully.";
  IncomingMessageText["fileMessageSent"] = "File is healthy";
  IncomingMessageText["sessionInitialized"] = "Session successfully initialized.";
  return IncomingMessageText;
}({});
export var MAX_RECONNECT_ATTEMPTS = 10;